export const environment = {
  production: true,
  // api: "http://192.168.18.167:8078/",
  api: "https://api.evok-performance.com/",
  latestProductKey: "latestProductKey",
  clientSecret: "61c890e8-7365-4022-bef9-b7e05588d574"
};

